// Mirrors the API's ServicePrepaymentMode. The API sends enum names, but numeric values are
// accepted too, as with the other payment enums.
export const PrepaymentMode = {
  NotRequired: 'NotRequired',
  Deposit: 'Deposit',
  FullPrepayment: 'FullPrepayment',
};

export const DepositType = {
  FixedAmount: 'FixedAmount',
  Percentage: 'Percentage',
};

const PREPAYMENT_MODE_BY_NUMBER = ['NotRequired', 'Deposit', 'FullPrepayment'];
const DEPOSIT_TYPE_BY_NUMBER = ['FixedAmount', 'Percentage'];

export const normalizePrepaymentMode = (mode) => {
  if (typeof mode === 'number') {
    return PREPAYMENT_MODE_BY_NUMBER[mode] || PrepaymentMode.NotRequired;
  }

  const match = Object.values(PrepaymentMode).find((value) => value.toLowerCase() === String(mode || '').toLowerCase());
  return match || PrepaymentMode.NotRequired;
};

export const normalizeDepositType = (type) => {
  if (typeof type === 'number') {
    return DEPOSIT_TYPE_BY_NUMBER[type] || DepositType.FixedAmount;
  }

  const match = Object.values(DepositType).find((value) => value.toLowerCase() === String(type || '').toLowerCase());
  return match || DepositType.FixedAmount;
};

export const requiresPrepayment = (mode) => normalizePrepaymentMode(mode) !== PrepaymentMode.NotRequired;

export default PrepaymentMode;
